export default function (amount) {
    return new Intl.NumberFormat(
        'pt-BR',
        {
            style: 'currency',
            currency: 'BRL',
        })
            .format(amount / 100)
            .replace('R$', '');
}



// WEBPACK FOOTER //
// ./scripts/util/moneyFormat.js